import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter, customFilter } from '../../../utility/Utils';
import { Edit } from 'react-feather';
import { useLocation } from 'react-router-dom';
import Select from '../../../components/Select/Select';

const SelectComponent = (props) => {
  const location = useLocation();
  const { row, value, label, type, saveChanges, flag } = props;
  const { employee: userPermission } = useSelector((state) => state.userPermissions);
  const [editable, setEditable] = useState(false);
  const [option, setOption] = useState({ value, label });
  const [hover, setHover] = useState(false);
  const allDivisions = useSelector((state) => state.projects.allDivisions);
  const refSelectContainer = useRef(null);

  useEffect(() => {
    setOption({ value, label });
  }, [row]);
  const theme = useSelector((state) => state.layout.themeMode);
  const [userWritePermission, setUserWritePermission] = useState({
    read: true,
    write: true,
  });

  const isAdmin = localStorage.getItem('is_admin');
  useEffect(() => {
    if (userPermission.is_admin === true) {
      setUserWritePermission({ read: true, write: true });
    } else if (userPermission?.EmployeePermission && userPermission?.EmployeePermission.permissions) {
      if (!userPermission?.EmployeePermission?.permissions) setUserWritePermission({ read: true, write: true });
      else {
        const { permissions } = userPermission?.EmployeePermission;
        if (location.pathname === '/project-managers') setUserWritePermission(permissions.project_managers);
        else setUserWritePermission(permissions.projects);
      }
    }
  }, [userPermission]);

  const updateOption = (e) => {
    const old_value = option.value;
    setEditable(false);
    saveChanges(row.id, type, e.value, old_value);
    setOption(e);
  };
  const allOptions = [];
  allDivisions?.forEach((div) => {
    allOptions.push({
      value: div.id,
      label: div.name,
    });
  });
  capitalizeFirstLetter(option);

  return (
    <Fragment>
      {!editable ? (
        <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          {(hover === true && userWritePermission && userWritePermission.write === true) || (hover === true && isAdmin === 'true') ? (
            <span>
              <Edit
                color={theme === 'dark' ? 'white' : 'black'}
                className='editIcon'
                onClick={() => {
                  setEditable(true);
                  setHover(false);
                }}
              />
              {capitalizeFirstLetter(option.label)}
            </span>
          ) : (
            <span>{capitalizeFirstLetter(option.label)}</span>
          )}
        </div>
      ) : (
        <div ref={refSelectContainer}>
          <Select
            placeholder={`Select`}
            value={option.label !== 'N/A' ? capitalizeFirstLetter(option) : ''}
            options={allOptions}
            menuPlacement='auto'
            menuPortalTarget={document.body}
            closeMenuOnScroll={(e) => {
              if (e.target.className === 'ant-table-body') {
                return true;
              } else {
                return false;
              }
            }}
            isSearchable={true}
            filterOption={customFilter}
            height={5}
            className='w-100'
            onChange={updateOption}
            getPopupContainer={(trigger) => trigger.parentNode}
            onBlur={() => setEditable(false)}
            autoFocus={true}
          />
        </div>
      )}
    </Fragment>
  );
};
export default SelectComponent;
